import { render, staticRenderFns } from "./DealExistingComponent.vue?vue&type=template&id=6fff1ad4&scoped=true"
import script from "./DealExistingComponent.vue?vue&type=script&lang=js"
export * from "./DealExistingComponent.vue?vue&type=script&lang=js"
import "./DealExistingComponent.vue?vue&type=style&index=0&id=6fff1ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff1ad4",
  null
  
)

export default component.exports